import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import SiteHeader from './SiteHeader';
import SiteFooter from './SiteFooter';
import useAnalytics from '../../hooks/useAnalytics';
import useSeo from '../../hooks/useSeo';

export default function SiteLayout() {
    const { pathname } = useLocation();
    useAnalytics();
    useSeo(pathname);
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [pathname]);

    return (
        <div className="dt-space-bg min-h-screen text-foreground relative" data-testid="site-layout">
            <SiteHeader />
            <main className="relative">
                <Outlet />
            </main>
            <SiteFooter />
        </div>
    );
}
